export default __webpack_public_path__ + "static/media/blog3_image.4a43591d.png";